import { EnrollmentStatus } from '@zorro/clients';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Box } from '@zorro/web/design-system';

import { getEnrollmentStatusView } from './EnrollmentStatusUtils';
import { useEnrollmentStatusViewer } from './useEnrollmentStatusViewer';

type Props = {
  enrollmentStatus: EnrollmentStatus;
  iconSize?: string | number;
  withBackground?: boolean;
  isEmployeeView?: boolean;
};

export function EnrollmentStatusIconTooltip({
  enrollmentStatus,
  iconSize,
  withBackground = true,
  isEmployeeView,
}: Props) {
  const viewer = useEnrollmentStatusViewer(isEmployeeView);
  const { renderIcon, tooltipLabel } = getEnrollmentStatusView(
    enrollmentStatus,
    viewer
  );

  return (
    <Tooltip label={tooltipLabel} position="top" disabled={!tooltipLabel}>
      <Box pos="relative" style={{ flexShrink: 0 }}>
        {renderIcon(iconSize, withBackground)}
      </Box>
    </Tooltip>
  );
}
